
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAAB7UExURQAAADh7/zl5/zh6/zl6/zh6/zh3/0Bw/zl6/zd5 /zl5/zh3/zl7/zd5/zl7/0B//zh5/zl5/zh6/3ej/83e/12T//L3/////3aj/83d/+bu/9rm/2qb /+bv/1GK/0WC/1GL/7TN/460/5u8/5y9/7TO/5u9/4Ks/wAAAAFLKmcAAAASdFJOUwBAj9/PnyAQ kI/PQM/PjxDfP5LbpTEAAAABYktHRACIBR1IAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH 5wwEAzkjI6K5XQAAAMhJREFUKM+Vkn0PgiAQhy8UX7KyLhSUFF+yvv83DNIVOmjr+YPb7tndYPwA NDsS4IqQRjATJ+ggjd8uRCd7YxP0kAJE6CUD6pcEDn4ZwFyvbEUxdxdZlNyiFCuJzJYVemQtmFPK W8PrVjUuKRV2Vauka22tOtaicQ7JhF5ayJ8X+lv2tuw3Ug3jODb6mboMaiMNd95P/GE1LCnMuokL S36j1Q3mfLafxhFO/v+kkPmljqd3lOj05b+iCblzlsRL5iO6mT6Ti+m/AAWTN/sXnbK4AAAAJXRF WHRkYXRlOmNyZWF0ZQAyMDIzLTEyLTA0VDAyOjMyOjEwKzAwOjAwwee5awAAACV0RVh0ZGF0ZTpt b2RpZnkAMjAyMy0xMi0wNFQwMjozMjoxMCswMDowMLC6AdcAAAAodEVYdGRhdGU6dGltZXN0YW1w ADIwMjMtMTItMDRUMDM6NTc6MzUrMDA6MDAkuNBQAAAAAElFTkSuQmCC"}})])
          )
        }
      }
    